<template>
  <div class="contentBox flex flex-between">
    <div class="leftBox">
      <div class="info-box flex">
        <div class="info-box-left">
          <div class="img-box flex flex-middle flex-center" style="overflow: hidden">
            <img
              :src="
                baseInfo.cal_Manage_avatar_address
                  ? baseInfo.cal_Manage_avatar_address
                  : 'https://picture.aiyizhijian.com/image/jpg/647282927881094400.jpg'
              "
            />
          </div>
        </div>
        <div class="info-box-right">
          <div class="flex flex-middle">
            <span class="bold name">{{ clinicInfo.sysusername ? clinicInfo.sysusername : '' }}</span>
            <img src="@/assets/img/yishizheng.png" />
            <!-- <span class="rank">主任医师</span> -->
          </div>
          <div class="info-box-right-t">
            <span>
              <el-tag>{{ clinicInfo.Operatoridentity === 'admin' ? '诊所管理员' : '诊所医生' }}</el-tag> /{{
               clinicInfo.sysuser ? clinicInfo.sysuser : ''
              }}</span>
          </div>
        </div>
        <div class="erweima" @click="openDialogEwm">
          <el-tooltip class="item" effect="dark" content="诊所专属二维码" placement="left-end">
            <img src="@/assets/img/erweimaw.png" alt="" />
          </el-tooltip>
        </div>
      </div>

      <div class="card_box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="订单明细" name="first">
            <balance-data />
          </el-tab-pane>
          <el-tab-pane label="充值记录" name="second">
            <recharge-data v-if="activeName === 'second'" />
          </el-tab-pane>
          <el-tab-pane label="往来明细" name="third">
            <business-data v-if="activeName === 'third'" />
          </el-tab-pane>
          <!-- <el-tab-pane label="提现记录" name="fourth">
            <withdraw-data v-if="activeName === 'fourth'" />
          </el-tab-pane>
          <el-tab-pane label="订单核销" name="fifth">
            <verification-data v-if="activeName === 'fifth'" />
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </div>
    <div class="rightBox">
      <div class="rightBoxContent">
        <div style="height: 180px">
          <el-carousel height="180px" indicator-position="none">
            <el-carousel-item v-for="item in 3" :key="item">
              <div class="right-box-c-t">
                <img src="@/assets/img/gg1.jpg" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="right-box-info flex flex-middle">
          <span class="title">{{ baseInfo.cal_name ? baseInfo.cal_name : '' }}</span>
          <img src="../../../assets/img/renzheng.png" />
          <!-- <span class="renzhen">已认证</span> -->
        </div>
        <div class="info-address">
          <p class="time">营业时间：{{ baseInfo.cal_Office_hours ? baseInfo.cal_Office_hours : '' }}</p>
          <p class="address">诊所地址：{{ baseInfo.cal_Office_address ? baseInfo.cal_Office_address : '' }}</p>
          <!-- <p class="address">诊所地址： 四川省,绵阳市,江油市,三合镇,江油市三合镇建设北路华丽佳苑</p> -->
        </div>
        <div class="doctor-mngr">
          <doctor-mngr />
        </div>
      </div>
    </div>
    <!-- 微信支付弹出层 -->
    <el-dialog :visible.sync="dialogEwm" width="370px" class="dialogWXAdd" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="dialogWalletContent">
        <div class="tilte">手机扫码添加诊所</div>
        <div id="qrCodeAdd" ref="qrCodeAdd">
          <!-- <img id="qrCodeIco" src="../../../assets/img/renzheng.png" alt="" /> -->
        </div>
        <div class="tips">让诊所医生成为您身边的健康管家</div>
      </div>
      <!-- <div class="dialogWXBtn">
        <el-button type="info" icon="el-icon-error" @click="handleClosePassword2">取消支付</el-button>
        <el-button type="primary" icon="el-icon-success" @click="completePaySure">已&nbsp;支&nbsp;付</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request';
import QRCode from 'qrcodejs2'; //二维码
import BalanceData from './components/BalanceData.vue';
import RechargeData from './components/RechargeData.vue';
import BusinessData from './components/BusinessData.vue';
import DoctorMngr from './components/DoctorMngr.vue';
// import VerificationData from './components/VerificationData.vue';
// import WithdrawData from './components/WithdrawData.vue';

export default {
  components: { BalanceData, RechargeData, BusinessData, DoctorMngr },
  name: 'Clinic',
  data() {
    return {
      clinicInfo: {}, //诊所权限
      baseInfo: {}, //诊所基本信息
      activeName: 'first',
      currentPage4: 1,
      switchValue: true,
      tabPosition: '1',
      tabPositionTime: '1',
      circleUrl: '',
      tableTime: [],
      list: ['充', '退', '核'],
      list2: ['1', '2', '3'],
      list4: ['1', '2'],
      options: [
        {
          value: '选项1',
          label: '黄金糕'
        },
        {
          value: '选项2',
          label: '双皮奶'
        },
        {
          value: '选项3',
          label: '蚵仔煎'
        },
        {
          value: '选项4',
          label: '龙须面'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ],
      value: '', //交易类型
      dialogEwm: false //诊所二维码显示隐藏
    };
  },
  created() {
    this.clinicInfo = JSON.parse(sessionStorage.user);
    this.getBaseClinicInfo();
    // console.log('hsdsuhdajsk', JSON.parse(sessionStorage.user));
  },
  mounted() {},
  methods: {
    // 生成二维码
    openDialogEwm() {
      this.dialogEwm = true;
      this.createQrcode();
    },
    // 诊所二维码生成
    createQrcode() {
      //二维码的生成
      let code = 'https://cloud.hwason.cn/weixin/qyminiprogram?calcode=' + JSON.parse(sessionStorage.user).cal_code; //固定格式
      this.$nextTick(() => {
        document.getElementById('qrCodeAdd').innerHTML = '';
        let qrcode = new QRCode('qrCodeAdd', {
          width: 260,
          height: 260, // 高度
          text: code
        });
        // var img = document.getElementById('#qrCodeIco');
        // var ewm = document.getElementById('#qrCodeAdd');
        // img.css('position:absolute;width:20px;height:20px');
        // //控制logo图标的位置
        // var margin = (ewm.height() - img.height()) / 2;
        // ewm.css('margin', margin);
      });
    },
    // tab切换事件
    handleClick(tab, event) {
      // console.log(tab, event);
      // console.log('activeName值为:', this.activeName);
    },
    // 获取诊所基本信息
    getBaseClinicInfo() {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        cal_code: clinicInfo.cal_code,
        DisableState: 'F'
      };
      const params = {
        token: clinicInfo.token,
        datatab: '296cxruOyduue3onJ6cL5CtrN7yxndVsAzfZ/rPujyPd1vItGUWCCA4yZIk',
        select:
          '33683I3JL7U/9MlrcChF+RXZIgMtRP/yvKnOaeGEaSehadZfiELa4+dATapSOOiznW/NnrokIA8ly4qNEkeDcTxpXnSCX6lPQkL9ik8BriGnBDghNeCSfHNCYXs2Wa/6eCqxnoLSCnkCRrZrFsj9oCa2K2VN/vO8HpzLPO835ckBuxjrg48GZpQVDvLfbmDRSusEvJFVgFSLpKBQFrGC9xW+DtFvi737nM2znXl9qAFnDHHnQU0UBbTzHfUv2W70//n9cP88lZ8FU/4QU2Tum1FP1Q',
        obgb: '88a4ufqmzpSyAKIfHrBbB1uD/QWSBC/+oi+zz3CbVpWEqL0ItLawFE2euvDd99dLnq/84OGX+P89lCbgNXre8xGgIxGy/z/fQls',
        LIKE: 'nl',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getkehulbapi.php', params)
        .then((res) => {
          // if (res.order_summary_library.IsOk === 'success') {
          //   that.$message.success('恭喜，保存信息成功');
          // } else {
          //   that.$message.error('抱歉，保存信息失败');
          // }
          that.baseInfo = res[0];
        })
        .catch((err) => {});
    },

    handleSizeChange(val) {},
    handleCurrentChange(val) {}
  }
  // table1
};
</script>

<style scoped lang="scss">
/* 诊所二维码弹出层 */
.dialogWXAdd {
  // border: 1px solid rgb(217, 255, 0);
  .dialogWalletContent {
    height: 360px;
    width: 320px;
    // border: 1px solid red;
    .tilte {
      height: 33px;
      opacity: 1;
      font-size: 24px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: #1890ff;
      line-height: 33px;
      margin: 0px auto 20px;
    }
    .tips {
      width: 287px;
      height: 28px;
      opacity: 1;
      border: 1px solid #1890ff;
      border-radius: 15px;
      text-align: center;
      line-height: 28px;
      color: #1890ff;
      margin: 15px auto;
    }
    #qrCodeAdd {
      background-color: white;
      height: 260px;
      width: 260px;
      // border: 1px solid red;
      margin: 0 auto;
      // position: absolute;
      // z-index: 20;
      // left: 94px;
      // top: 155px;
    }
  }
  .dialogWXBtn {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    // border: 1px solid rgb(29, 127, 207);
  }
}
// .el-tabs {
//   border-radius: 10px !important;
//   /deep/ .el-tabs__header{
//     border-radius: 10px 10px 0 0;
//     /deep/ .el-tabs__item.is-activ {
//       border-top-left-radius: 10px;
//     }
//   }
// }
.card_box {
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
  padding: 15px;
  margin-top: 10px;
  overflow: hidden;
}

::v-deep .el-card__body {
  padding: 0px;
}

::v-deep .el-input-group__prepend {
  border-radius: 12px 0px 0px 12px;
}
::v-deep .el-input__inner {
  border-radius: 0px 12px 12px 0px;
}
.contentBox {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 90px);

  .leftBox {
    flex: 1;
    height: 100%;

    // info
    .info-box {
      background-color: #fff;
      border-radius: 30px;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
      padding: 15px 40px;
      // border: 2px solid red;
      position: relative;

      .erweima {
        position: absolute;
        // border-radius: 0 30px 0 0;
        top: 0;
        right: 2px;
        overflow: hidden;
        cursor: pointer;
      }

      .info-box-left {
        .img-box {
          // background-color: #2d99d7;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          margin-left: 8px;
          margin-bottom: 8px;

          img {
            width: 75px;
            height: 75px;
          }
        }

        .user-rank {
          background-color: #e5f6ff;
          border-radius: 17px;
          line-height: 28px;
          padding: 0 11px;
          font-size: 14px;
          font-weight: 400;
          color: #2d99d7;
        }
      }

      .info-box-right {
        margin-left: 35px;
        padding-top: 5px;
        .name {
          font-size: 26px;
          color: #333333;
        }

        img {
          width: 35px;
          height: 35px;
          margin: 0 10px;
        }

        .rank {
          display: inline-block;
          padding: 3px 17px;
          border: 1px solid #ffc910;
          border-radius: 15px;
          font-size: 15px;
          font-weight: 400;
          color: #ffc512;
        }

        .info-box-right-t {
          margin-top: 10px;
          color: #999;
          font-size: 20px;
        }
      }
    }
  }

  .rightBox {
    // border: 1px solid red;
    height: calc(100vh - 90px);
    width: 265px;
    margin: 0 20px 0 10px;
    box-sizing: border-box;

    .rightBoxContent {
      height: calc(100vh - 90px);
      padding: 10px;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
      background: #fff;
      border-radius: 30px;
      width: 100%;
      box-sizing: border-box;
      // border: 2px solid rgb(0, 204, 255);
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .doctor-mngr {
        flex: 1;
        width: 100%;
      }

      .right-box-c-t {
        img {
          display: inline-block;
          width: 100%;
          border-radius: 20px;
        }
      }

      .right-box-info {
        margin-top: 10px;
        // border: 2px solid goldenrod;

        .title {
          font-size: 18px;
          color: #333333;
          font-weight: bold;
          margin-right: 10px;
        }

        img {
          width: 26px;
          height: 26px;
          margin-right: 5px;
        }

        .renzhen {
          color: #ffc512;
          font-size: 16px;
        }
      }

      .info-address {
        margin-top: 10px;
        color: #666;
        font-size: 14px;
        font-weight: 400;

        .time {
          margin-bottom: 5px;
        }
      }
    }
  }
}

::v-deep .el-collapse-item__header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding-left: 32px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 120px;
  line-height: 28px;
  background-color: #fff;
  color: #303133;
  cursor: pointer;
  border-bottom: 1px solid #ebeef5;
  font-size: 13px;
  font-weight: 500;
  -webkit-transition: border-bottom-color 0.3s;
  transition: border-bottom-color 0.3s;
  outline: 0;
}

::v-deep .el-dialog {
  border-radius: 15px !important;
}
::v-deep [data-v-1addaf1f] .el-input__inner {
  border-radius: 12px;
}
</style>
